// extracted by mini-css-extract-plugin
export default {"Wrapper":"InterventionView_Wrapper__a5ZOY","Content":"InterventionView_Content__KsZRX"};